import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useData, useStatus } from 'resift';
import getSources from 'fetches/getSources';
import Loader from 'components/Loader';
import ChooseSourceType from './ChooseSourceType';

function Container() {
  const dispatch = useDispatch();
  const sourcesData = useData(getSources);
  const status = useStatus(getSources);

  useEffect(() => {
    dispatch(getSources('demo-data'));
  }, []);

  return (
    <Loader status={status}>
      <ChooseSourceType sourcesWithDemoData={sourcesData} />
    </Loader>
  );
}

export default Container;
